module.exports = __webpack_public_path__ + "static/fonts/iconfont.c5a8eb5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.woff2?t=1627006594184
// module id = vpPO
// module chunks = 78